import styled from "styled-components";
import { colors } from "@/theme";

export const ProductCartSubtotalsAndShippingContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  padding: 16px 24px;
`;

export const ProductCartSubtotalsAndShipping = styled.div`
  display: flex;
  padding: 4px;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  border-radius: 12px;
  border: 1px solid ${colors.doveGray};
`;
